function GoogleReviewSection() {
  return (
    <section id="reviews" className="section">
      <div className="review-card">
        <p className="eyebrow">Your Feedback</p>
        <h2>Rate Us on Google Maps</h2>
        <p>
          If you are happy with our service, please share your rating on Google
          Maps. Your review helps more local families trust our work.
        </p>
        <div className="review-actions">
          <a
            className="primary-btn"
            href="https://maps.app.goo.gl/rs1f4VowSRc5AvEu9"
            target="_blank"
            rel="noopener noreferrer"
          >
            Rate on Google Maps
          </a>
        </div>
      </div>
    </section>
  );
}

export default GoogleReviewSection;
